const SET_PAGES = (state, data) => {
  state.pages = data
}

export default {
  SET_PAGES
}
